var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ActiveTab ValidationTab"},[_c('LocatieInformatieHeader',{attrs:{"chargingpoint":_vm.chargingpoint}},[_c('h4',[_vm._v(_vm._s(_vm.$t('components.sidebar.Tabs.ParticipationTab')))])]),_c('div',{staticClass:"ActiveTab__Content"},[_c('ParticipationComments',{attrs:{"chargingpoint":_vm.chargingpoint}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }